import { render } from "./CookieTooltipPopup.vue?vue&type=template&id=329eb722"
import script from "./CookieTooltipPopup.vue?vue&type=script&lang=js"
export * from "./CookieTooltipPopup.vue?vue&type=script&lang=js"

import exportComponent from "/home/sunfix/ultrabalance-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__